//@ts-ignore
function lazyLoad(view) {
  return () => import("@/pages/" + view + ".vue");
}
// add name of routes
export const noGuardRoutes = ["home", "about", "login", "projects", "edit-project"];
export const routes = [
  {path: "/", name: "home", component: lazyLoad("core/Body")},
  {path: "/admin", name: "login", component: lazyLoad("login/Login")},
  {
    path: "/admin",
    component: lazyLoad("admin/Admin"),
    children: [
      {
        path: "projets",
        component: lazyLoad("admin/projects/Index"),
        children: [
          {path: "", name: "projects", component: lazyLoad("admin/projects/List"),},
          {path: "edition/:token", name: "edit-project", component: lazyLoad("admin/projects/Edit")},
          { path: "creation", name: "create-project", component: lazyLoad("admin/projects/Edit") },
        ],
      },
    ],
  },
];
